

const TRANSLATIONS_EN_CA = {
    "email_otp.back":"Back",
    "email_otp.enter_email_text":"Enter your email address below to have a unique code sent to you",
    "email_otp.send_verification_link":"Send Verification Code",
    "email_otp.resend_otp_with_timer":"Resend OTP in",
    "email_otp.text":"We’ve sent a 6-digit verification code to [email]. Please enter the code below",
    "email_otp.verify":"Verify",
    "reset_password.set_password":"Set Your Password",
    "sign_in.or":"or",
    "sign_in.continue_with":"Or Continue With",
    "sign_in.continue_with_email":"Or Continue With Email",
    "sign_in.create_without_password":"Create an Account Without Password",
    "sign_in.create_with_otp":"Create an Account With One-Time Passcode",
    "sign_in.login_with_otp":"Sign In With One-Time Passcode",
    "sign_in.login_without_password":"Sign In Without Password",
    "sign_in.tooltip_text":"You will receive a temporary unique verification code via email to gain access to your account.",
    "sign_up.tooltip_text":"You will receive a temporary unique verification code via email to create an account.",
    "sign_in.password_updated":"Your password has been updated.",
    "sign_up.create_an_account":"Create an Account",
    "email_otp.resend_otp":"Resend OTP",
    "sign_up.email_address":"Email Address",
    "sign_up.password":"Password",
    "sign_in.create_account" : "Create An Account",
    "sign_in.title": "Sign In",
    "sign_in.forgot_password" : "Forgot your password?",
    "reset_password.resend_email": "Resend Email",
    "reset_password.sent_title": "Email has been sent!",
    "reset_password.rcvResetLink": "Enter your email address below and we’ll send you a password reset link. ",
    "reset_password.submit": "Submit",
    "reset_password.back_to_login": "Back to Login",
    "reset_password.create_new_password": "Create a new password to log in to your account.",
    "forgot_password.emailSent": "If an account exists for [], an email will be sent with a password reset link. Still not showing up? Request a new email below.",
    "gdpr.continue": "Continue",
    "validation.password_validation_heading": "Password must include:",
    "validation.password_length_ui": "At least 8 characters",
    "validation.password_upper_case_ui": "An uppercase character",
    "validation.password_lower_case_ui": "A lowercase character",
    "validation.password_number_ui": "A number",
    "validation.password_symbol_ui": "A special character",
    "verify_otp.customer_service_center_link": "s/customer-service",
    "activate_user.verification_successful.message": "Congratulations! Your account has been activated.",
    "activate_user.already_verified.message" : "Welcome back! Your account has already been verified.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Please fill in all mandatory fields before you proceed.",
    "sign_in.invalid_email_error": "Please enter email in proper format e.g. name@domain.com",
    "sign_in.invalid_credentials_error": "You have entered an invalid username or password. Please try again.",
    "sign_in.generic_error": "Something went wrong. Please try again.",
    "sign_in.account_unverified_error": "Your account is not yet activated. Please check your email for the activation link, or click 'Forgot your password' to reset your account access.",
    "sign_in.max_attempt_error": "Maximum attempts reached. Please try again later.",
    "sign_in.social_signin_error": "Social (Google/Facebook/Apple) sign in failed. Please try again or use another sign-in method",
    "sign_in.social_signin_email_not_present_error": "Sign-in failed. Please try again or use another sign-in option.",
    "sign_in.guest_user_signin_error": "Looks like you already have an account with this email. Click ‘Forgot your password’ to reset your account access.",

    "sign_up.mandatory_field_error": "Please fill in all mandatory fields before you proceed.",
    "sign_up.invalid_email_error": "Please enter a valid email address. e.g. name@domain.com",
    "sign_up.password_length_error": "Password must be at least 8 characters long.",
    "sign_up.email_already_exist_error": "This email already exists. Please use a different email.",
    "sign_up.generic_error": "Something went wrong. Please try again.",
    "sign_up.password_policy_error": "Password must include: a number, special character [!#$%&'*+-/=?^_`{|}~.@], uppercase and lowercase letters.",
    "sign_up.common_password_error": "Password cannot be the same as your email address",

    "forgot_password.mandatory_field_error": "Please fill in all mandatory fields before you proceed.",
    "forgot_password.invalid_email_error": "Please enter email in proper format e.g. name@domain.com",
    "forgot_password.generic_error": "Something went wrong. Please try again.",

    "reset_password.mandatory_field_error": "Please fill in all mandatory fields before you proceed.",
    "reset_password.password_history_error": "Password must be different from your previous five passwords.",
    "reset_password.password_length_error": "Password must be at least 8 characters long.",
    "reset_password.password_policy_error": "Password must include: a number, special character [!#$%&'*+-/=?^_`{|}~.@], uppercase and lowercase letters.",
    "reset_password.common_password_error": "Password cannot be the same as your email address",
    "reset_password.generic_error": "Something went wrong. Please try again.",

    "email_otp.email_required_error": "Please enter your email to continue",
    "email_otp.invalid_email_error": "Please enter a valid email address. e.g. name@domain.com",
    "email_otp.generic_error": "Something went wrong. Please try again later",
    "email_otp.invalid_otp_error": "The OTP/verification code you entered is invalid. Please try again.",
    "email_otp.resend_otp_error": "Unable to resend OTP. Please try again later",
    "email_otp.verify_otp_error": "Something went wrong. Please retry OTP verification later",
    "email_otp.verify_otp_limit_exceed_error": "Entered OTP is invalid. Please click 'Resend OTP' to get a new one",
    "email_otp.max_attempt_reached_error": "Maximum attempts reached. Please try again later.",
    "email_otp.brute_force_error_part_1": "Your account has been temporarily locked due to multiple unsuccessful login attempts. Please try again later, or ",
    "email_otp.brute_force_error_part_2": "contact our Help Centre",
    "email_otp.brute_force_error_part_3": " for assistance.",
    "form.gdprconsent": "By signing in, you have read and agree to our",
    "form.termsCondition": "Terms & Conditions",

    //Page Titles
    "sign_in.page_title": "Sign In | Pens.com",
    "sign_up.page_title":"Sign Up | Pens.com",
    "forgot-password.page_title": "Forgot Password | Pens.com",
    "reset-password.page_title": "Reset Password | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_EN_CA;